export const clearModalArtifacts = () => {
	if (typeof document === "undefined") return;
	document.querySelectorAll(".modal-backdrop").forEach((backdropNode) => backdropNode.remove());
	if (document.body) {
		document.body.classList.remove("modal-open");
		document.body.style.removeProperty("overflow");
		document.body.style.removeProperty("padding-right");
	}
};
